module.exports = __webpack_require__.p + "56912e0931306991c05ec5f39f415216.jpg";